<template>
  <section class="padd-40 visible-lg" id="home-block">
    <div class="container">
      <div class="row" data-aos="fade-up">
        <div class="col-md-12">
          <div class="heading">
            <h2>{{ $t('suggestion.title') }}</h2>
            <p>{{ $t('suggestion.desc') }} &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/blogs" target="_blank">查看其他内容</router-link></p>
            <a ref="mytarget" class="hidetarget" href="" target="_blank" rel="noopener noreferrer"></a>
          </div>
        </div>
      </div>
      
      <div class="row grid" style="position:relative;padding-right:396px;max-width:1195px;left:22px;" v-if="data.homepage && data.list">

        <div class="col-md-6 col-sm-12 col-xs-12">
          <div class="row">
            <div class="col-md-12 col-xs-12 grid1" :style="getStyle1(data.homepage.image)" @click="openNewTab(data.homepage.url)">
              <!--<a href="https://space.bilibili.com/549774238/article" target="_blank"><img :src="data.homepage.image"></a>-->
            </div>
            <div class="col-md-6 col-xs-6" style="margin-top:32px;">
              <div class="row">
                <div class="col-md-12 col-xs-12" :style="getStyle(data.list[0].image, 0)">
                  <!--<a href="https://cn.accaglobal.com/insights.html" target="_blank"><img :src="data.list[0].image" class="square"></a>-->
                </div>
                <div class="col-md-12 col-xs-12 grid4">
                  <router-link :to="'/blogs/' +  data.list[0].url" target="_blank">{{ data.list[0].title }}</router-link>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xs-6" style="margin-top:32px;">
              <div class="row">
                <div class="col-md-12 col-xs-12" :style="getStyle(data.list[1].image, 1)">
                  <!--<a href="https://abmagazine.accaglobal.com/uk/en.html" target="_blank"><img :src="data.list[1].image"></a>-->
                </div>
                
                <div class="col-md-12 col-xs-12 grid4">
                  <router-link :to="'/blogs/' +  data.list[1].url" target="_blank">{{ data.list[1].title }}</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-12 col-xs-12">
          <div class="row">
            <div class="col-md-12 col-xs-12 grid1" style="width:calc(100vw * 400/1440 + 10px);height:calc(100vw * 400/1440 + 10px);max-width:400px;max-height:400px;margin-left:15px;">
              <a :href="data.homepage.url" target="_blank">
              <h3>{{ data.homepage.title }}</h3></a><br />
              <span style="font-size:16px;"><a :href="data.homepage.url" target="_blank">{{ data.homepage.desc }}</a></span>
            </div>
            <div class="col-md-6 col-xs-6" style="margin-top:32px;">
              <div class="row">
                <div class="col-md-12 col-xs-12" :style="getStyle(data.list[2].image, 2)">
                  <!--<a href="https://cn.accaglobal.com/employee/employer/certificate-in-data-analytics.html" target="_blank"><img :src="data.list[2].image"></a>-->
                </div>
                <div class="col-md-12 col-xs-12 grid4" style="padding-right:10px">
                  <router-link :to="'/blogs/' +  data.list[2].url" target="_blank">{{ data.list[2].title }}</router-link>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xs-6" style="margin-top:32px;">
              <div class="row">
                <div class="col-md-12 col-xs-12" :style="getStyle(data.list[3].image, 3)">
                  <!--<a href="https://jobs.accaglobal.com/article/how-to-embed-diversity-and-inclusion-in-your-accountancy-firm/" target="_blank"><img :src="data.list[3].image"></a>-->
                </div>
                
                <div class="col-md-12 col-xs-12 grid4" style="padding-right:10px">
                  <router-link :to="'/blogs/' +  data.list[3].url" target="_blank">{{ data.list[3].title }}</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-item one-third lap-one-whole portable-one-whole palm-one-whole" style="position:absolute;top:0px;right:24px;width:317px;">

            <section class="recruiter-cta brick">
              <div class="brick__inner cf">
                <h2 class="brick__header"><span>招贤纳士</span></h2>
                <p>从全球超过70万ACCA会员、未来会员中找到合适您企业的最佳人选。</p>
                <p class="recruiter-cta__action" style="padding-top:10px"><a href="https://login.accacnjobs.com/" target="_blank" class="button button--brand icon-after icon-white" data-icon="">发布职位</a></p>
              </div>
            </section>
          </div>
        
      </div>

    </div>
  </section>
</template>
<style>
.hidetarget {
    width: 0;
    height: 0;
  }
.recruiter-cta {
    background: url('/img/recruiter-cta.jpg') no-repeat center center;
    background-size: cover;
    padding: 120px 0 30px 0;
    left: 80px;
    margin-top: 0px;
    /*margin-bottom: 100px;
    width: 80%;*/


    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    -webkit-box-align: end;
    -ms-flex-align: end;
    align-items: flex-end;
    /*padding-bottom: 57.7%;*/
}
.brick {
    display: block;
  width: 317px;
  height: 550px;
}
.button--brand {
    text-align: center;
    text-transform: none;
    background: #fff;
    color: #000;
    padding: 10px 20px;
    font-family: avenir;
    font-weight: 600;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 6px 0 rgb(0 0 0 / 16%);
    box-shadow: 0 1px 6px 0 rgb(0 0 0 / 16%);
}
.brick__header {
  color: #FFFFFF;
  font-size: 24px;
}
.recruiter-cta .brick__inner {
  position: relative;
    /*width: 115%;*/
    left: -24px;
    bottom: -230px;
}
.brick__inner {
    background: #c80000;
    padding: 16px 40px 26px 40px;
    padding-right: 30px;
    width: 75%;
    margin-top:200px;
    color: #FFFFFF;
    width: 365px;
    height: 215px;
}
.grid img {
  max-width: 100%;
    max-height: 100%;
    width:100%;
    height:100%;
}
.grid-container {
  display: grid;
  grid-template-columns: repeat(36, 1fr);
  grid-template-rows: repeat(20, 1fr);
}
.grid-container img {
  max-width: 100%;
    max-height: 100%;
    width:100%;
    height:100%;
}
.s1 {
  position: relative;
    padding-bottom: 100%;
    height: 0; 
}
.square {
  position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: 50% 50%;
}
.grid1 {
  padding: 0 5px 0 12px;
}
.grid2 {
  padding: 0 10px 0 0
}
.grid3 {
  padding: 10px 10px 0 0
}
.grid4 {
  padding: 5px 5px 0 0;
  font-size: 16px;
}
@media only screen and (max-width:480px) {
  .grid1 {
    padding: 0 0 5px 0
  }
  .grid2 {
    padding: 0
  }
  .grid3 {
    padding: 0
  }
  .grid4 {
    padding: 0
  }
}
</style>
<script>
export default {
  name: 'HomeBlock',
  data: function () {
    return {
      data: [],
    }
  },
  methods: {
    openNewTab(url) {
      let target = this.$refs.mytarget
      target.setAttribute('href', url)
      target.click()
    },
    getStyle: function(url, i) {
      let margin = '10px'
      if (i == 3) 
        margin = '0px'
      return {
        maxWidth: '195px',
        maxHeight: '195px',
        height: 'calc(100vw * 200/1440 - 5px)',
        width: 'calc(100vw * 200/1440 - 5px)',
        backgroundImage: 'url('+ url + ')',
        backgroundSize: 'cover',
        backgroundPosition: '50% 50%',
        marginTop: '10px',
        marginRight: margin
      }
    },
    getStyle1: function(url) {
      return {
        maxWidth: '400px',
        maxHeight: '400px',
        height: 'calc(100vw * 400/1440 + 10px)',
        width: 'calc(100vw * 400/1440 + 10px)',
        backgroundImage: 'url('+ url + ')',
        backgroundSize: 'cover',
        backgroundPosition: '50% 50%'
      }
    },
    getStyle2: function() {

    }
  },
  created: function() {
    let that = this,
        url = this.BLOG_API_PREFIX + 'index.html'
    this.$http.get(url).then(function (response) {
      that.data = response.data.info
    }).catch(e => console.error(e))
  }
}
</script>
